import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrdersComponent } from './orders.component';

const routes: Routes = [
  {
    path: ':orderId/authorize',
    loadChildren: () => import('../order-wizard/order-wizard.module').then((m) => m.OrderWizardModule),
  },
  { path: ':orderId', component: OrderDetailsComponent, data: { title: 'Order Details' } },
  { path: '**', component: OrdersComponent, data: { title: 'Orders' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
